import React from 'react'
import PropTypes from 'prop-types'

const AddCartWrapper = ({ children }) => {
  return (
    <div className='row'>
      <div className='col-12'>
        {children}
      </div>
    </div>
  )
}

AddCartWrapper.propTypes = {
  children: PropTypes.elementType
}

export default AddCartWrapper



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/AddCartWrapper.js